/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_R1Inputs */



/**
* | output |
* | --- |
* | "R1 Predator-prey repeat" |
*
* @param {Rounds_R1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_r1 = /** @type {((inputs?: Rounds_R1Inputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_R1Inputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("R1 Répétition prédateur-proie")
	if (locale === "es") return /** @type {LocalizedString} */ ("R1 Repetir depredador-presa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("R1 Repetição predador-presa")
	if (locale === "it") return /** @type {LocalizedString} */ ("R1 Ripetizione predatore-preda")
	return /** @type {LocalizedString} */ ("R1 Predator-prey repeat")
});